import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

const createLoadingComponent = () => {
	return UFOLoadHold({
		name: 'LoadingConfluenceConversationAssistantBundle',
	});
};

export const ConfluenceConversationAssistant: LoadableType<
	Omit<
		{
			onClosePanel?: () => void;
			children?: React.ReactNode;
		},
		'flags'
	>
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConversationAssistant" */ '../src/main.tsx'))
			.ConfluenceConversationAssistant,
	loading: createLoadingComponent,
});
